import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { ProductInput } from "../../../input/ProductInput/ProductInput";
import { ProductOption } from "../../../input/ProductInput/types";
import { ProductPresenceDataType } from "../types";

interface ProductConfigStepProps {
  columnName: string;
  dataType: string;
  selectedIds: number[];
  onColumnNameChange: (name: string) => void;
  onDataTypeChange: (dataType: string) => void;
  onSelectedIdsChange: (ids: number[]) => void;
}

export const ProductConfigStep: React.FC<ProductConfigStepProps> = ({
  columnName,
  dataType,
  selectedIds,
  onColumnNameChange,
  onDataTypeChange,
  onSelectedIdsChange,
}) => {
  const handleProductsSelect = (products: ProductOption[]) => {
    const ids = products.map((product) => Number(product.value));
    onSelectedIdsChange(ids);
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Configure Product Column
      </Typography>

      <Stack spacing={3}>
        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Column Name
          </Typography>
          <TextField
            fullWidth
            value={columnName}
            onChange={(e) => onColumnNameChange(e.target.value)}
            placeholder="Enter column name"
            size="small"
          />
        </Box>

        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Select Products
          </Typography>
          <ProductInput
            selectedProductIds={selectedIds}
            onProductsSelect={handleProductsSelect}
            placeholder="Search and select products..."
          />
          {selectedIds.length > 0 && (
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
              {selectedIds.length} product{selectedIds.length !== 1 ? "s" : ""}{" "}
              selected
            </Typography>
          )}
        </Box>

        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Data Format
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              value={dataType}
              onChange={(e) => onDataTypeChange(e.target.value)}
            >
              <FormControlLabel
                value={ProductPresenceDataType.Y_N}
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body2">Yes/No Format</Typography>
                    <Typography variant="caption" color="text.secondary">
                      Shows "Yes" if any selected products are installed, "No"
                      otherwise
                    </Typography>
                  </Box>
                }
              />
              <FormControlLabel
                value={ProductPresenceDataType.ONE_ZERO}
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body2">1/0 Binary Format</Typography>
                    <Typography variant="caption" color="text.secondary">
                      Shows "1" if any selected products are installed, "0"
                      otherwise
                    </Typography>
                  </Box>
                }
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </Stack>
    </Box>
  );
};
